<template>
  <div class="edit-article-page">
    <v-overlay
      :absolute="true"
      :value="loading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <template v-if="!loading">
      <page-editor
        v-if="podcast"
        pageTitle="Podcast"
        :podcast="podcast"
        @refreshData="fetchData"
      />
      <div
        v-else
        style="height: 100vh"
        class="d-flex justify-center align-center"
      >
        <h2>Unabled to retrieve data. <router-link :to="{ name: 'sportsbetting-categories' }">Go back</router-link>
        </h2>
      </div>
    </template>

  </div>
</template>

<script>
import PageEditor from './create'
import Podcast from '@/models/Podcast'

export default {
  name: 'EditPodcastPage',

  data () {
    return {
      podcast: null,
      loading: true
    }
  },

  components: {
    PageEditor

  },

  methods: {
    async fetchData () {
      this.loading = true
      await Podcast.get()
        .then(response => {
          this.podcast = new Podcast(response.data[0])
        })
        .catch(e => {
          if (e.response.data.http_status === 404) {
            this.podcast = {}
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  },

  mounted () {
    this.fetchData()
  }
}
</script>

<style scoped>
.edit-article-page {
  min-height: 100vh;
}
</style>
